import { render, staticRenderFns } from "./PaymentManagement.vue?vue&type=template&id=52004770"
import script from "@/scripts/payment/paymentManagement.js?vue&type=script&lang=js&external"
export * from "@/scripts/payment/paymentManagement.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports